// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"XQ-z","inlineTitle":"YQ-z","sponsoredAdsWrapper":"ZQ-z","marketplaceRecosWrapper":"_Q-z"};